export default {
  EMAIL_FIELD:
  /(name="(\w+email|email\w+|email|cmp1|kmbSubscribe\[email\]|mauticform\[email\])")/ig,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/config/regex.js
 **/